import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function ReferenceSection({ form, set }) {
  return (
    <div className="bg-white p-6 rounded-2xl border border-neutral-200/70 space-y-4">
      <h2 className="font-display font-semibold text-lg">Reference</h2>
      <div className="grid sm:grid-cols-2 gap-4">
        <div><Label>Reference name</Label><Input value={form.reference_name} onChange={(e) => set("reference_name", e.target.value)} data-testid="careers-ref-name"/></div>
        <div><Label>Reference phone</Label><Input value={form.reference_phone} onChange={(e) => set("reference_phone", e.target.value)} data-testid="careers-ref-phone"/></div>
      </div>
    </div>
  );
}
